import routes from '@/router/routes';
import { createRouter, createWebHistory } from 'vue-router';
import { getCookie } from '@/helpers/cookie';
import { clearAllAuthData } from '@/helpers/auth';
import $http from '@/plugins/axios';
import { inject } from 'vue';
import { trackDatadogView } from '@/plugins/datadog/rum';
const $swal = inject('$swal');

const history = createWebHistory();

const router = createRouter({
  history,
  linkActiveClass: 'active',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
});

router.beforeEach(async (to, from, next) => {
  setTitleThisRoute(to);
  const token = getCookie('token');
  if (to.meta.requiresAuth) {
    if (!token) {
      // Usar a função centralizada de limpeza
      clearAllAuthData();
      next({ name: 'login' });
    } else {
      // Verificar se é rota de criação de pedido/boleto/reserva e se o usuário é apenas Atendimento
      if (to.name === 'orderCreate' || to.name === 'billetCreate' || to.name === 'cardsReserveCreate' || to.name === 'cardRequestCreate') {
        try {
          const retrievedUser = localStorage.getItem('user');
          if (retrievedUser) {
            const userObject = JSON.parse(retrievedUser);
            const userId = userObject.id;

            const response = await $http.get(`/user/getById?id=${userId}`);
            const roles = response.data.roles.map(e => e.name);
            const isAtendimentoOnly = roles.includes('Atendimento') &&
                                       !roles.includes('Administrador') &&
                                       !roles.includes('Operacional') &&
                                       !roles.includes('Financeiro') &&
                                       !roles.includes('Comercial');

            if (isAtendimentoOnly) {
              // Redirecionar para a lista apropriada baseada na rota
              if (to.name === 'cardsReserveCreate') {
                next({ name: 'cardsReserveList' });
              } else if (to.name === 'cardRequestCreate') {
                next({ name: 'cardRequestList' });
              } else {
                next({ name: 'orderAwardedList' });
              }
              return;
            }
          }
        } catch (error) {
          $swal.fire({
            title: 'Oops!',
            text: error.response.data[0].message || error.response.data.message || 'Não foi possível concluir a operação nesse momento, tente novamente mais tarde',
            icon: 'error',
            confirmButtonText: 'Voltar'
          });
        }
      }
      next();
    }
  } else {
    if (token != null) next({ name: 'home' });
    else next();
  }
});

router.afterEach((to) => {
  trackDatadogView(to);
});

function setTitleThisRoute (to) {
  // set default values same title, icon and breadcrumb...
  window.document.title = `${to.meta.title  } - OnlyPay` || 'OnlyPay - Soluções de pagamento';
  // window.document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description || 'OnlyPay - Soluções de pagamento')
}

export default router;
